module.exports = __webpack_public_path__ + "img/block-excited.e1e8bfaf.jpg";